// extracted by mini-css-extract-plugin
module.exports = {"tagWrapper":"tag-wrapper_tagWrapper__J0cFY","tagName":"tag-wrapper_tagName__zP42f","tagWrapperLight":"tag-wrapper_tagWrapperLight__T2p47"};